const FloorplanFeaturesEnum = Object.freeze({
    BayWindows: 'Bay Windows',
    BreakfastArea: 'Breakfast Area',
    CoveredFrontPorch: 'Covered Front Porch',
    CoveredPatio: 'Covered Patio',
    Fireplaces: 'Fireplaces',
    FlexSpace: 'Flex Space',
    GreenConstruction: 'Green Construction',
    MudRoom: 'Mud Room',
    Playroom: 'Playroom',
    RVGarage: 'RV Garage',
    VaultedCeilings: 'Vaulted Ceilings',
    WalkInClosets: 'Walk In Closets',
    WraparoundPorch: 'Wraparound Porch',
});

export default FloorplanFeaturesEnum;
